import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';

import { PaymentService } from '../services/payment.service';
import { PaymentComponent } from './payment.component';
import { PaymentRoutingModule } from './payment-routing.module';
import {MatCheckboxModule} from '@angular/material/checkbox';
import {MatRadioModule} from '@angular/material/radio';

@NgModule({
  providers:[PaymentService],
  imports: [
    SharedModule,
    PaymentRoutingModule,
    MatCheckboxModule,
    MatRadioModule
  ],
  declarations: [
    PaymentComponent,
  ]
})
export class PaymentModule { }
